// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Ws from "@apollo/client/link/ws";
import * as ApolloClient__SubscriptionsTransportWs from "../../../../subscriptions-transport-ws/ApolloClient__SubscriptionsTransportWs.bs.js";

var Js_ = {};

var Configuration = {
  Js_: Js_
};

var Js_$1 = {};

function make(uri, options, webSocketImpl, param) {
  return new Ws.WebSocketLink(({
                NAME: "Configuration",
                VAL: {
                  uri: uri,
                  options: Belt_Option.map(options, ApolloClient__SubscriptionsTransportWs.ClientOptions.toJs),
                  webSocketImpl: webSocketImpl
                }
              }).VAL);
}

function makeWithSubscriptionClient(subscriptionClient) {
  return new Ws.WebSocketLink(subscriptionClient);
}

var WebSocketLink = {
  ClientOptions: undefined,
  SubscriptionClient: undefined,
  Configuration: Configuration,
  Js_: Js_$1,
  make: make,
  makeWithSubscriptionClient: makeWithSubscriptionClient
};

var ApolloLink;

var Graphql;

export {
  ApolloLink ,
  Graphql ,
  WebSocketLink ,
}
/* @apollo/client/link/ws Not a pure module */
